import { Injectable } from '@angular/core';

export type GalleryItem = {
  src: string;
  alt: string;
  layout: 'standard' | 'tall' | 'wide' | 'hero';
  delay: string;
};

export type GalleryContent = {
  badge: string;
  heading: string;
  lede: string;
  items: GalleryItem[];
};

@Injectable({ providedIn: 'root' })
export class GallerySectionService {
  readonly content: GalleryContent = {
    badge: 'Gallery',
    heading: 'Fresh-from-the-studio moments.',
    lede:
      'Real pets, calm handling, and polished finishes from recent grooms.',
    items: [
      {
        src: 'assets/shared/gallery/gallery1%20(1).jpg',
        alt: 'Grooming gallery image 1',
        layout: 'wide',
        delay: '140ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(2).jpg',
        alt: 'Grooming gallery image 2',
        layout: 'tall',
        delay: '180ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(3).jpg',
        alt: 'Grooming gallery image 3',
        layout: 'standard',
        delay: '220ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(4).jpg',
        alt: 'Grooming gallery image 4',
        layout: 'hero',
        delay: '260ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(5).jpg',
        alt: 'Grooming gallery image 5',
        layout: 'standard',
        delay: '300ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(6).jpg',
        alt: 'Grooming gallery image 6',
        layout: 'tall',
        delay: '340ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(7).jpg',
        alt: 'Grooming gallery image 7',
        layout: 'wide',
        delay: '380ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(8).jpg',
        alt: 'Grooming gallery image 8',
        layout: 'standard',
        delay: '420ms'
      },
      {
        src: 'assets/shared/gallery/gallery1%20(9).jpg',
        alt: 'Grooming gallery image 9',
        layout: 'standard',
        delay: '460ms'
      }
    ]
  };
}
